import React from 'react';
import PropTypes from 'prop-types';
import { C, Masks, retrievePrecisionNumber } from 'shared/helpers';

import Styles from './Table.module.scss';

import EtapaTile from './Etapa/Etapa';
import CompTile from './Comp/Comp';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

export default function NewTable({ etapas, tableKey, phase, renderables, tableRef, quantidade = 'Qtde (Kg/ha)' }) {
  const {
    Master,
    Table,
    Result,
    Row,
    Fixed,
    Top,
    Flexer,
    Total,
    NPK,
    Darker,
  } = Styles;

  let rowCount = 0;
  const k = () => `${tableKey}${++rowCount}`;
  const { number, currency } = Masks;
  const { formatNumber } = useIntl();
  const mapProdutos = useSelector((state) => state.produtos.map || {});

  return (
    <div className={Master} ref={tableRef}>
      <header>Nutrientes Fornecidos Kg/ha</header>
      <div className={C(Table, Fixed)}>
        <div className={C(Flexer)}>
          <header className={Fixed}>
            <div style={{ minWidth: '100px' }}>Etapa Fenológica</div>
            <div style={{ minWidth: '100px' }}>Época de Aplicação</div>
            <div style={{ minWidth: '120px' }}>Produto</div>
            <div>N</div>
            <div>P2O5</div>
            <div>K2O</div>
            <div>{quantidade && quantidade !== '' ? quantidade : 'Qtde (Kg/ha)'}</div>
          </header>
          <header>
            {renderables.map((x, i) => (
              <div key={k()}>
                {x}
                {[7, 9, 10, 11, 12, 13].includes(i) ? (
                  <p style={{ color: 'red' }}>*</p>
                ) : (
                    ''
                  )}
              </div>
            ))}
            <div style={{ minWidth: '100px' }}>Preço do Produto (R$/ton)</div>
            <div style={{ minWidth: '100px' }}>Custo Nutricional</div>
          </header>
        </div>
        <div>
          {etapas.map((etapa, etapaIndex) => {
            const iprodutos = etapa.produtos
              .filter((y) => y.fase_id === phase)
              .map((ep) => mapProdutos[ep.id])
              .filter(p => !!p)
              .map((z) => ({
                ...z,
                ...etapa.produtos.find(
                  (a) => a.id === z.id && a.fase_id === phase,
                ),
              }));
            // const iprodutos = Produtos.filter((x) =>
            //   etapa.produtos.some((y) => y.id === x.id && y.fase_id === phase),
            // )
            //   .sort(
            //     (p1, p2) =>
            //       iprodutosOrder.indexOf(p1.id) - iprodutosOrder.indexOf(p2.id),
            //   )

            const ietapa = {
              ...etapa,
              produtos: etapa.produtos.filter((x) => x.fase_id === phase),
            };

            return [
              <div key={k()} className={Top}>
                <EtapaTile
                  etapaIndex={etapaIndex}
                  etapa={ietapa}
                  produtos={iprodutos}
                  tableKey={tableKey}
                />
                <CompTile
                  etapaIndex={etapaIndex}
                  etapa={ietapa}
                  produtos={iprodutos}
                  tableKey={tableKey}
                  key={k()}
                  phase={phase}
                  renderables={renderables}
                />
              </div>,
            ];
          })}
        </div>
        <div className={Row}>
          <div className={Total}>TOTAL</div>
          <div
            className={C(Total, Result)}
            style={{ left: '500px', zIndex: '1' }}
          >
            {number(
              etapas.map((etapa) => {
                const produtos = etapa.produtos.filter(
                  (a) => a.fase_id === phase,
                );
                let total = 0;
                for (let i = 0; i < produtos.length; i++) {
                  total += Number(produtos[i].quantidade);
                }
                return total;
              }),
            )}
          </div>
          {renderables.map((x) => (
            <div key={k()} className={C(Total, Result)}>
              {number(
                etapas.map((etapa) => {
                  const produtos = etapa.produtos.filter(
                    (a) => a.fase_id === phase,
                  );
                  let total = 0;
                  for (let i = 0; i < produtos.length; i++) {
                    total +=
                      (Number(produtos[i].quantidade) / 100) *
                      Number(
                        // (Produtos.find((x) => x.id === produtos[i].id) || {
                        (mapProdutos[produtos[i].id] || {
                          [x]: 0,
                        })[x],
                      );
                  }
                  return total;
                }), { ed: retrievePrecisionNumber(x) },
              )}
            </div>
          ))}
          <div className={Darker} />
          <div className={C(Total, Result)} style={{ minWidth: '98px' }}>
            {`${currency(
              etapas.map((etapa) => {
                const produtos = etapa.produtos.filter(
                  (a) => a.fase_id === phase,
                );
                let total = 0;
                for (let i = 0; i < produtos.length; i++) {
                  total += Number(
                    (produtos[i].valor / 1000) * produtos[i].quantidade,
                  );
                }
                return total;
              }),
              { ed: 0 },
            )} /ha`}
          </div>
        </div>
        <div
          style={{ zIndex: '1', left: '500px', position: 'sticky' }}
          className={Row}
        >
          <div className={C(Total, NPK)}>Relação NPK</div>
          {etapas
            .reduce((grupos, etapa) => {
              const RENDERABLES = renderables.filter((r) =>
                ['N', 'P2O5', 'K2O'].includes(r),
              );
              RENDERABLES.forEach((r, i) => {
                grupos[i] =
                  (grupos[i] || 0) +
                  etapa.produtos
                    .filter((a) => a.fase_id === phase)
                    .reduce(
                      (sum, produto) =>
                        sum +
                        (produto.quantidade / 100) *
                        // (Produtos.find((p) => p.id === produto.id) || {})[
                        (mapProdutos[produto.id] || {})[r] || 0,
                      0,
                    );
              });
              return grupos;
            }, [])
            .map((soma, i, somas) => {
              const relacao = soma / somas[0];
              return (
                <div className={C(Total, Result)} key={i.toString()}>
                  {!relacao || relacao === Infinity
                    ? formatNumber(0, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : formatNumber(relacao, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

NewTable.defaultProps = {};

NewTable.propTypes = {
  tableKey: PropTypes.string.isRequired,
  etapas: PropTypes.any.isRequired,
  phase: PropTypes.number.isRequired,
  renderables: PropTypes.arrayOf(PropTypes.string).isRequired,
};
